import { PaymentMethodSummaryFactory } from '@/components/modules/Application/components/_shared/components/ApplicationSummary/components/ApplicationSummaryPaymentMethods/components/PaymentMethodSummaryFactory';
import { SummaryTitle } from '@/components/modules/Application/components/_shared/components/ApplicationSummary/components/SummaryTitle';
import { usePaymentMethods } from '@/components/modules/Application/components/PaymentMethod/_shared/hooks/usePaymentMethods';

export const ApplicationSummaryPaymentMethods = () => {
  const { selectedPaymentMethods, currency } = usePaymentMethods();

  if (!selectedPaymentMethods || !currency) return null;

  return (
    <>
      <SummaryTitle title={'PAYMENT_METHODS'} />
      {selectedPaymentMethods.map((paymentMethodEntity) => {
        return (
          <PaymentMethodSummaryFactory
            key={paymentMethodEntity.paymentMethodType}
            paymentMethodEntity={paymentMethodEntity}
          />
        );
      })}
    </>
  );
};
